import React from "react";
import {
  useClearRefinements,
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";

function ListingTypeMobile({ listingType, setListingType }) {
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,
    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({
    attribute: "listingType",
    // defaultRefinement: "RENT",
  });
  const clearListingType = useClearRefinements({
    includedAttributes: ["listingType"],
  });

  //console.log(items);
  const rent = items.find((el) => el?.value == "RENT");
  const sale = items.find((el) => el?.value == "SALE");
  //   console.log(lab);

  //   console.log(items);

  const props = useCurrentRefinements();
  //console.log(props.items, props.canRefine, props.createURL)
  const itemRefs = props.items;
  // console.log(itemRefs);
  const arr = itemRefs.find((c) => c.attribute === "RENT");
  //   console.log(arr);
  // console.log(rent.isRefined);
  // console.log(sale.isRefined);
  return (
    <div className=" flex h-10 flex-shrink-0 flex-row items-center">
      <div
        onClick={() => {
          clearListingType.refine();
        }}
        className={
          " flex h-full  w-1/3 cursor-pointer select-none items-center justify-center  rounded-l-md " +
          (!rent?.isRefined && !sale?.isRefined
            ? "  bg-ula-blue text-gray-100"
            : "border  border-b border-l border-r-0 border-t border-gray-300")
        }
      >
        All
      </div>
      <div
        onClick={() => {
          if (sale?.isRefined) {
            clearListingType.refine();
            setListingType("Rent");
            refine("RENT");
          } else if (!rent?.isRefined) {
            setListingType("Rent");
            refine("RENT");
          }
        }}
        className={
          " flex h-full  w-1/3 cursor-pointer select-none items-center  justify-center " +
          (rent?.isRefined
            ? " bg-ula-blue text-gray-100"
            : "border  border-b border-l-0 border-r-0 border-t border-gray-300")
        }
      >
        For rent
      </div>
      <div
        onClick={() => {
          if (rent?.isRefined) {
            clearListingType.refine();
            setListingType("Sale");
            refine("SALE");
          } else if (!sale?.isRefined) {
            setListingType("Sale");
            refine("SALE");
          }
        }}
        className={
          " flex h-full  w-1/3 cursor-pointer select-none items-center justify-center  rounded-r-md " +
          (sale?.isRefined
            ? " bg-ula-blue text-gray-100"
            : "border-b  border-l-0 border-r border-t  border-gray-300")
        }
      >
        For sale
      </div>
    </div>
  );
}

export default ListingTypeMobile;
